import * as React from 'react';
import { Route } from 'react-router-dom';
import { WebsiteInstitutionPage } from './WebsiteInstitutionPage';

export const getWebsiteInstitutionRoutes = (): React.ReactNode => (
  <>
    <Route path="institution/:id" element={<WebsiteInstitutionPage />} />
  </>
);
